<template>
    <v-card>
        <v-container grid-list-md>
            <v-layout row wrap v-if="!loading">
                <v-flex md4 sm4 xs12>
                    <v-img :src="imgDataUrl"
                           height="351px">
                    </v-img>
                </v-flex>
                <v-flex md8 sm8 xs12>
                    <v-list three-line>
                        <v-list-tile>
                            <v-list-tile-action>
                                <v-icon>perm_identity</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title class="text--secondary">No. de Control</v-list-tile-title>
                                <v-list-tile-sub-title class="text--primary">{{alumno.noDeControl}}</v-list-tile-sub-title>
                            </v-list-tile-content>
                        </v-list-tile>
                        <v-divider inset></v-divider>
                        <v-list-tile>
                            <v-list-tile-action>
                                <v-icon>account_box</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title class="text--secondary">Nombre Completo</v-list-tile-title>
                                <v-list-tile-sub-title class="text--primary">{{alumno.nombreCompleto}}</v-list-tile-sub-title>
                            </v-list-tile-content>
                        </v-list-tile>
                        <v-divider inset></v-divider>
                        <v-list-tile>
                            <v-list-tile-action>
                                <v-icon>class</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title class="text--secondary">Carrera</v-list-tile-title>
                                <v-list-tile-sub-title class="text--primary">{{alumno.carrera}}</v-list-tile-sub-title cla>
                            </v-list-tile-content>
                        </v-list-tile>
                        <v-divider inset></v-divider>
                        <v-list-tile>
                            <v-list-tile-action>
                                <v-icon></v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title class="text--secondary">Semestre Actual</v-list-tile-title>
                                <v-list-tile-sub-title class="text--primary">{{alumno.semestre}}</v-list-tile-sub-title>
                            </v-list-tile-content>
                        </v-list-tile>
                    </v-list>
                </v-flex>
            </v-layout>
            <v-progress-linear :indeterminate="true" v-else="loading"></v-progress-linear>
        </v-container>
    </v-card>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'Perfil',
    data: () => ({
      localStatus: false,
      imgDataUrl: ''
    }),
    created () {
      const BASE_URL = this.$store.getters.getBaseURL
      const img = new Image()

      img.onload = () => {
        this.imgDataUrl = this.userImage
      }
      img.onerror = () => {
        this.imgDataUrl = BASE_URL + '/uploads/00000000.png?' + (new Date()).getTime()
      }
      img.src = this.userImage
    },
    computed: {
      ...mapState({
        alumno: state => state.user.profile,
        loading: state => {
          return state.user.status === 'loading'
        },
        userImage: state => {
          console.log(state.user.profile.foto)
          return state.user.profile.foto + '?' + (new Date()).getTime()
        }
      })
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Perfil.vue